import React, { memo, useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Form,
  FormGroup,
  Row,
  InputGroupAddon,
  FormFeedback,
  CardBody,
  Card,
  Collapse,
} from "reactstrap";
import IntlMessages from "../../../helpers/IntlMessages";
import PerfectScrollbar from "react-perfect-scrollbar";

import { AddCommaNumber, getImageUrl } from "../../../helpers/Utils";
import PriceInput from "../../../components/common/PriceInput";
import Creatable from "../../../components/common/CreatableSelect";
import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import SizeAndTopping from "./SizeAndTopping";
import IceAndSugar from "./IceAndSugar";
import DynamicForm from "../general/DynamicForm";
import RecipeBuilder from "./RecipeBuilder";
import StockInfo from "./StockInfo";
import TooltipItem from "../../../components/common/TooltipItem";
import { Validator } from "../../../helpers/Validator";
import moment from "moment";
import DatePicker from "react-datepicker";

const ContentComponent = ({
  business_type,
  title,
  isOpen,
  show_add_more_topping,
  onShowMoreItem,
  show_quantitative,
  onShowQuantitative,
  toggle,
  onUpdate,
  onSubmit,
  handleKeyPress,
  onAddSizeAndTopping,
  onChangeSizeAndTopping,
  onRemoveSizeAndTopping,
  data_dynamic_form,
  values,
  form_cost,
  sku,
  editProduct,
  isSavingProduct = false,
  data_categories,
  data_stocks,
  make_products,
  generatedVariants,
  handleGenerateVariants,
  toggleAccordionVariations,
  masterVariantSettings,
  handleVariantChange,
  handleMasterSettingsChange,
  applyMasterSettingsToAll,
  allSizeOptions,
  allColorOptions,
  allMaterialOptions,
  brandOptions,
  saleUnitOptions,
  handleDeleteVariant,
  onAddStock,
  onAddNewStock,
  setting,
  onChange,
  onChangeCost,
  onDeleteImage,
  onDeleteStock,
  onChangeIceAndSugar,
  onChangeDynamicForm,
}) => {
  const avatar = values?.image?.preview;
  const existingImages = Array.isArray(values.images_old)
    ? values.images_old
    : [];
  const newImages = Array.isArray(values.images) ? values.images : [];
  const totalImageCount = existingImages.length + newImages.length;
  const parsePriceValue = (value) => {
    if (value === null || value === undefined || value === "") return 0;
    const normalizedValue = String(value).replace(/\./g, "").replace(/,/g, ".");
    const parsedValue = Number.parseFloat(normalizedValue);
    return Number.isFinite(parsedValue) ? parsedValue : 0;
  };
  const isFoodService =
    business_type === "cafe" || business_type === "restaurant";
  const hasSizeBasedPrice =
    isFoodService &&
    Array.isArray(values.size) &&
    values.size.some((size) => parsePriceValue(size?.value) > 0);
  const categoryOptions = Array.isArray(data_categories) ? data_categories : [];
  const getCategoryOptionLabel = (option) =>
    option?.label || option?.name || option?.value || "";
  const getCategoryOptionValue = (option) =>
    String(option?.value ?? option?.id ?? option?.name ?? "");
  const selectedCategoryOption = (() => {
    if (!values?.category && !values?.category_id) return null;

    if (values?.category && typeof values.category === "object") {
      return values.category;
    }

    const categoryId = values?.category_id || values?.category;
    const matchedCategory = categoryOptions.find(
      (category) => getCategoryOptionValue(category) === String(categoryId),
    );

    if (matchedCategory) return matchedCategory;
    if (!values?.category) return null;

    return {
      label: String(values.category),
      value: values.category,
    };
  })();

  useEffect(() => {
    return () => {
      avatar && URL.revokeObjectURL(avatar);
    };
  }, [avatar]);

  useEffect(() => {
    const rules = [
      Validator.isRequired(
        'input[name="category"]',
        "Vui lòng chọn danh mục",
      ),
    ];

    if (!hasSizeBasedPrice) {
      rules.push(Validator.isRequired("#price"));
    }

    Validator({
      form: "#form-product",
      formGroupSelector: ".form-group",
      errorSelector: ".form-message",
      rules,
      onSubmit: (data) => {},
    });

    if (hasSizeBasedPrice) {
      const priceInput = document.querySelector("#price");
      const priceFormGroup = priceInput?.closest(".form-group");
      const errorElement = priceFormGroup?.querySelector(".form-message");
      if (priceFormGroup) priceFormGroup.classList.remove("invalid");
      if (errorElement) errorElement.innerText = "";
    }

    return () => {};
  }, [values, hasSizeBasedPrice]);

  const make_product = make_products?.filter(
    (product) => product.product_id === values.id,
  );

  let priceCostWithValuesId = make_product
    ?.map((item) => {
      let price = data_stocks?.find(
        (i) => i.id === item.stock.id,
      )?.avarage_price;
      return parseFloat(item.count) * parseFloat(price);
    })
    .reduce((sum, item) => sum + item, 0);

  let priceCostNoneId = form_cost?.make
    ?.map((item) => {
      let price = data_stocks?.find((i) => i.id === item.id)?.avarage_price;
      return parseFloat(item.count) * parseFloat(price);
    })
    .reduce((sum, item) => sum + item, 0);

  let findStock = data_stocks?.find((stock) => stock.sku === values.sku);

  const [categoryTooltip] = useState({
    placement: "top",
    text: "",
    body: 'Là danh mục cha của sản phẩm này. Ví dụ: Danh mục "Cà phê" là danh mục cha của sản phẩm "Cà phê sữa đá".',
  });

  const [priceTooltip] = useState({
    placement: "top",
    text: "",
    body: 'Giá này là giá bán ra của sản phẩm nếu như "Giá khuyến mãi" không được tick chọn.',
  });

  const [priceSaleTooltip] = useState({
    placement: "top",
    text: "",
    body: 'Giá này là giá bán ra của sản phẩm nếu như "Giá khuyến mãi" được tick chọn.',
  });

  const [priceWholesaleTooltip] = useState({
    placement: "top",
    text: "",
    body: "Giá bán sỉ của sản phẩm. Được hiển thị làm tùy chọn trong chi tiết sản phẩm.",
  });

  const [sizeTooltip] = useState({
    placement: "top",
    text: "",
    body: "Là nơi để nhập tên và giá tiền theo kích thước tương ứng được cộng thêm vào giá bán của sản phẩm này.",
  });

  const [toppingTooltip] = useState({
    placement: "top",
    text: "",
    body: 'Là nơi để nhập các "sản phẩm phụ" với sản phẩm này và giá tiền tương ứng được cộng thêm vào giá bán.',
  });

  const [iceTooltip] = useState({
    placement: "top",
    text: "",
    body: "Tick chọn 5 ô để khách hàng/người gọi sản phẩm có thể chọn Lượng đá của sản phẩm.",
  });

  const [sugarTooltip] = useState({
    placement: "top",
    text: "",
    body: "Tick chọn 5 ô để khách hàng/người gọi sản phẩm có thể chọn Độ ngọt của sản phẩm.",
  });

  const [quantityTooltip] = useState({
    placement: "top",
    text: "",
    body: "Số lượng dựa trên đơn vị đo lường của sản phẩm này.",
  });

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      backdrop={true}
      autoFocus={false}
      className="product-add-modal"
      modalClassName="product-mobile-right-drawer-modal"
      wrapClassName="product-mobile-right-drawer-wrap"
      style={{ maxWidth: "95vw", width: "95vw" }}
    >
      <Form
        onSubmit={
          editProduct
            ? (e) => {
                onUpdate(e);
              }
            : (e) => onSubmit(e)
        }
        id="form-product"
        className="product-add-form"
      >
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <div className="product-add-modal-body">
          <PerfectScrollbar
            options={{
              suppressScrollX: true,
              wheelPropagation: true,
            }}
            id="modal-right__body"
            className="product-add-scroll"
          >
            <Row className="product-add-layout">
              <Colxx lg="4" md="6" className="product-add-column product-add-column-1 product-add-column-left">
                <section className="product-add-section">
                  <div className="product-add-section-title">
                    Thông tin cơ bản
                  </div>
                <Row>
                  <Colxx xxs="12" className="has-float-label mt-3">
                    <FormGroup>
                      <Label>
                        <IntlMessages id="pages.product-name" />
                        <span style={{ color: "red" }}>*</span>
                      </Label>
                      <Input
                        autoFocus={true}
                        type="text"
                        name="name"
                        id="name"
                        placeholder="Nhập tên sản phẩm"
                        value={values.name}
                        onChange={onChange}
                      />
                      <span className="form-message p-0"></span>
                    </FormGroup>
                  </Colxx>
                </Row>
                <Row>
                  {/* Barcode - chỉ hiện cho các mô hình không phải cafe/restaurant */}
                  {business_type !== "cafe" &&
                    business_type !== "restaurant" && (
                      <Colxx xxs="7" className="has-float-label">
                        <FormGroup>
                          <Label>
                            <IntlMessages id="pages.product-barcode" />
                          </Label>
                          <Input
                            type="text"
                            name="barcode"
                            id="barcode"
                            maxLength={13}
                            value={values.barcode ?? ""}
                            onChange={onChange}
                            onKeyPress={(e) => handleKeyPress(e)}
                            placeholder="8-13 chữ số"
                            className={
                              values.barcode &&
                              values.barcode.length > 0 &&
                              values.barcode.length < 8
                                ? "border-danger"
                                : ""
                            }
                          />
                          {values.barcode &&
                          values.barcode.length > 0 &&
                          values.barcode.length < 8 ? (
                            <small className="text-danger">
                              Cần nhập ít nhất 8 chữ số ({values.barcode.length}
                              /8)
                            </small>
                          ) : null}
                        </FormGroup>
                      </Colxx>
                    )}
                  <Colxx
                    xxs={
                      business_type !== "cafe" && business_type !== "restaurant"
                        ? "5"
                        : "12"
                    }
                    className={
                      business_type !== "cafe" && business_type !== "restaurant"
                        ? "pl-0 has-float-label"
                        : "has-float-label"
                    }
                  >
                    <FormGroup>
                      <Label>
                        <IntlMessages id="pages.product-sku" />
                      </Label>
                      <Input
                        disabled
                        type="text"
                        name="sku"
                        id="sku"
                        placeholder="SKU được tạo tự động"
                        value={values.sku ? values.sku : sku}
                      />
                      <span className="form-message p-0"></span>
                    </FormGroup>
                  </Colxx>
                </Row>
                <Row>
                  <Colxx xxs="12" className="has-float-label">
                    <FormGroup>
                      <Label for="category">
                        <IntlMessages id="pages.category" />
                        {editProduct && <span style={{ color: "red" }}>*</span>}
                        <TooltipItem item={categoryTooltip} id={9} />
                      </Label>
                      <Creatable
                        placeholder={
                          editProduct
                            ? "Chọn hoặc tạo danh mục..."
                            : "Không chọn sẽ vào Chưa phân loại"
                        }
                        isClearable
                        className={"react-select-creatable"}
                        onChange={(val) => onChange(val, "category")}
                        options={categoryOptions}
                        getOptionLabel={getCategoryOptionLabel}
                        getOptionValue={getCategoryOptionValue}
                        formatCreateLabel={(value) =>
                          `Thêm danh mục "${value}"`
                        }
                        name="category"
                        id="category"
                        value={selectedCategoryOption}
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                          placeholder: (provided) => ({
                            ...provided,
                            fontSize: "0.8rem",
                            color: "#9ca3af",
                            opacity: 0.75,
                          }),
                        }}
                      />
                      <span className="form-message p-0"></span>
                    </FormGroup>
                  </Colxx>
                </Row>
                {isFoodService ? (
                  <Row>
                    <Colxx xxs="12" className="has-float-label">
                      <FormGroup>
                        <Label for="fnb_type">Loại sản phẩm</Label>
                        <Input
                          type="select"
                          name="fnb_type"
                          id="fnb_type"
                          value={
                            values.fnb_type ||
                            (business_type === "cafe" ? "drink" : "food")
                          }
                          onChange={onChange}
                          disabled={setting.viewonly && !setting.add}
                        >
                          <option value="food">Đồ ăn</option>
                          <option value="drink">Thức uống</option>
                        </Input>
                      </FormGroup>
                    </Colxx>
                  </Row>
                ) : null}
                <Row>
                  <Colxx sm="6" className="pr-sm-2 has-float-label">
                    <FormGroup>
                      <Label for="brand_name">Thương hiệu</Label>
                      <Creatable
                        isClearable
                        className="react-select-creatable"
                        classNamePrefix="react-select"
                        name="brand_name"
                        id="brand_name"
                        placeholder="Chọn hoặc tạo mới"
                        options={brandOptions}
                        value={
                          values.brand_name
                            ? typeof values.brand_name === "object"
                              ? values.brand_name
                              : {
                                  label: values.brand_name,
                                  value: values.brand_name,
                                }
                            : null
                        }
                        onChange={(option) =>
                          onChange(
                            option
                              ? typeof option === "object"
                                ? option.value
                                : option
                              : "",
                            "brand_name",
                          )
                        }
                        formatCreateLabel={(value) =>
                          `Thêm thương hiệu "${value}"`
                        }
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                          placeholder: (provided) => ({
                            ...provided,
                            fontSize: "0.8rem",
                            color: "#9ca3af",
                            opacity: 0.75,
                          }),
                        }}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx sm="6" className="pl-sm-2 has-float-label">
                    <FormGroup>
                      <Label for="sale_unit">Đơn vị tính</Label>
                      <Creatable
                        isClearable
                        className="react-select-creatable"
                        classNamePrefix="react-select"
                        name="sale_unit"
                        id="sale_unit"
                        placeholder="Chọn hoặc tạo mới"
                        options={saleUnitOptions}
                        value={
                          values.sale_unit
                            ? typeof values.sale_unit === "object"
                              ? values.sale_unit
                              : {
                                  label: values.sale_unit,
                                  value: values.sale_unit,
                                }
                            : null
                        }
                        onChange={(option) =>
                          onChange(
                            option
                              ? typeof option === "object"
                                ? option.value
                                : option
                              : "",
                            "sale_unit",
                          )
                        }
                        formatCreateLabel={(value) =>
                          `Thêm đơn vị tính "${value}"`
                        }
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                          placeholder: (provided) => ({
                            ...provided,
                            fontSize: "0.8rem",
                            color: "#9ca3af",
                            opacity: 0.75,
                          }),
                        }}
                      />
                    </FormGroup>
                  </Colxx>
                </Row>
                </section>

                <section className="product-add-section">
                  <div className="product-add-image-heading">
                    <div className="product-add-section-title mb-0">
                      Hình ảnh sản phẩm
                    </div>
                    {totalImageCount > 0 && (
                      <span className="product-add-image-count">
                        {totalImageCount} ảnh
                      </span>
                    )}
                  </div>
                  <FormGroup className="mb-0">
                    <Input
                      type="file"
                      id="images"
                      name="images"
                      multiple
                      accept="image/png,image/jpeg,image/webp"
                      onChange={onChange}
                      className="product-add-image-input"
                    />
                    <Label
                      for="images"
                      className="product-add-image-dropzone"
                    >
                      <span className="product-add-image-icon">
                        <i className="simple-icon-cloud-upload" />
                      </span>
                      <span className="product-add-image-copy">
                        <strong>Chọn hình ảnh sản phẩm</strong>
                        <span>Kéo thả hoặc bấm để tải ảnh lên</span>
                        <small>JPG, PNG hoặc WEBP · Khuyến nghị 320 × 240 px</small>
                      </span>
                      <span className="product-add-image-action">
                        <i className="simple-icon-plus" />
                        Chọn ảnh
                      </span>
                    </Label>

                    {totalImageCount > 0 && (
                      <div className="product-add-image-grid">
                        {existingImages.map((imageUrl, index) => (
                          <div
                            key={`old-${imageUrl}-${index}`}
                            className="product-add-image-preview"
                          >
                            <img
                              src={getImageUrl(imageUrl)}
                              alt={`Ảnh sản phẩm ${index + 1}`}
                            />
                            {index === 0 && (
                              <span className="product-add-image-primary">
                                Ảnh đại diện
                              </span>
                            )}
                            <button
                              type="button"
                              className="product-add-image-remove"
                              title="Xóa ảnh"
                              aria-label={`Xóa ảnh sản phẩm ${index + 1}`}
                              onClick={() => onDeleteImage(index, "old")}
                            >
                              <i className="simple-icon-trash" />
                            </button>
                          </div>
                        ))}
                        {newImages.map((file, index) => {
                          const imagePosition = existingImages.length + index;

                          return (
                            <div
                              key={`new-${file.name || index}-${index}`}
                              className="product-add-image-preview"
                            >
                              <img
                                src={file.preview}
                                alt={`Ảnh sản phẩm ${imagePosition + 1}`}
                              />
                              {imagePosition === 0 && (
                                <span className="product-add-image-primary">
                                  Ảnh đại diện
                                </span>
                              )}
                              <button
                                type="button"
                                className="product-add-image-remove"
                                title="Xóa ảnh"
                                aria-label={`Xóa ảnh sản phẩm ${
                                  imagePosition + 1
                                }`}
                                onClick={() => onDeleteImage(index, "new")}
                              >
                                <i className="simple-icon-trash" />
                              </button>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </FormGroup>
                </section>

                <section className="product-add-section">
                  <div className="product-add-section-title">Thông tin khác</div>
                  <Row>
                    <Colxx sm="6" className="pr-sm-2 has-float-label">
                      <FormGroup>
                        <Label for="softHide">Trạng thái sản phẩm</Label>
                        <Input
                          type="select"
                          name="softHide"
                          id="softHide"
                          value={values.softHide ? "true" : "false"}
                          onChange={(event) =>
                            onChange(
                              event.target.value === "true",
                              "softHide",
                            )
                          }
                        >
                          <option value="false">Đang bán</option>
                          <option value="true">Đang tạm ẩn</option>
                        </Input>
                      </FormGroup>
                    </Colxx>
                    <Colxx sm="6" className="pl-sm-2 has-float-label">
                      <FormGroup>
                        <Label for="weight">Trọng lượng (kg)</Label>
                        <Input
                          type="number"
                          min="0"
                          step="0.001"
                          name="weight"
                          id="weight"
                          placeholder="Nhập trọng lượng"
                          value={values.weight || ""}
                          onChange={onChange}
                        />
                      </FormGroup>
                    </Colxx>
                  </Row>
                  <div className="product-add-dimension-label">
                    Kích thước sản phẩm (cm)
                  </div>
                  <Row>
                    <Colxx xxs="4" className="pr-1 has-float-label">
                      <FormGroup>
                        <Label for="length">Dài</Label>
                        <Input
                          type="number"
                          min="0"
                          step="0.01"
                          name="length"
                          id="length"
                          placeholder="Chiều dài"
                          value={values.length || ""}
                          onChange={onChange}
                        />
                      </FormGroup>
                    </Colxx>
                    <Colxx xxs="4" className="px-1 has-float-label">
                      <FormGroup>
                        <Label for="width">Rộng</Label>
                        <Input
                          type="number"
                          min="0"
                          step="0.01"
                          name="width"
                          id="width"
                          placeholder="Chiều rộng"
                          value={values.width || ""}
                          onChange={onChange}
                        />
                      </FormGroup>
                    </Colxx>
                    <Colxx xxs="4" className="pl-1 has-float-label">
                      <FormGroup>
                        <Label for="height">Cao</Label>
                        <Input
                          type="number"
                          min="0"
                          step="0.01"
                          name="height"
                          id="height"
                          placeholder="Chiều cao"
                          value={values.height || ""}
                          onChange={onChange}
                        />
                      </FormGroup>
                    </Colxx>
                  </Row>
                  <DynamicForm
                    values={values.dynamic_form}
                    data={data_dynamic_form}
                    onChange={onChangeDynamicForm}
                    disabled={setting.viewonly && !setting.add}
                    showPlaceholders
                  />
                </section>
              </Colxx>

              <Colxx lg="4" md="6" className="product-add-column product-add-column-2">
                <section className="product-add-section">
                  <div className="product-add-section-title">
                    Thông tin giá &amp; tồn kho
                  </div>
                  <Row>
                    <Colxx sm={6} className="pr-sm-2 has-float-label">
                      <FormGroup>
                        <Label htmlFor="price">
                          <IntlMessages id="product.price.original" />
                          <span style={{ color: "red" }}>*</span>
                          <TooltipItem item={priceTooltip} id={10} />
                        </Label>
                        <PriceInput
                          name="price"
                          id="price"
                          placeholder="Nhập giá bán"
                          value={values.price}
                          onChange={onChange}
                          disabled={
                            (setting.viewonly && !setting.add) ||
                            hasSizeBasedPrice
                          }
                        />
                        {hasSizeBasedPrice ? (
                          <div className="product-add-price-mode-note">
                            Giá bán sẽ được lấy theo từng size
                          </div>
                        ) : null}
                        <span className="form-message p-0"></span>
                      </FormGroup>
                    </Colxx>
                    <Colxx sm={6} className="pl-sm-2 has-float-label">
                      <FormGroup>
                        <Label for="price_sale">
                          <Input
                            checked={values.active_sale}
                            onChange={() =>
                              onChange(!values.active_sale, "active_sale")
                            }
                            type="checkbox"
                            name="check"
                            id="checkbox-sale"
                            className="m-0"
                          />
                          <span className="pl-3">
                            <IntlMessages id="product.price.sale" />
                          </span>
                        </Label>
                        <PriceInput
                          disabled={!values.active_sale}
                          name="price_sale"
                          id="price_sale"
                          placeholder="Nhập giá khuyến mãi"
                          value={values.price_sale}
                          onChange={onChange}
                        />
                        <span className="form-message p-0"></span>
                      </FormGroup>
                    </Colxx>
                    {business_type !== "cafe" && business_type !== "restaurant" && (
                      <Colxx sm={6} className="pr-sm-2 has-float-label mt-3 mt-sm-0">
                        <FormGroup>
                          <Label for="price_wholesale">
                            <IntlMessages id="product.price.wholesale" />
                            <TooltipItem item={priceWholesaleTooltip} id={12} />
                          </Label>
                          <PriceInput
                            name="price_wholesale"
                            id="price_wholesale"
                            placeholder="Nhập giá bán sỉ"
                            value={values.price_wholesale}
                            onChange={onChange}
                            disabled={setting.viewonly && !setting.add}
                          />
                          <span className="form-message p-0"></span>
                        </FormGroup>
                      </Colxx>
                    )}
                    <Colxx
                      sm={6}
                      className={
                        business_type !== "cafe" && business_type !== "restaurant"
                          ? "pl-sm-2 has-float-label mt-3 mt-sm-0"
                          : "pr-sm-2 has-float-label mt-3"
                      }
                    >
                      <FormGroup>
                        <Label for="tax_rate">
                          <IntlMessages id="product.tax-rate" /> (%)
                        </Label>
                        <Input
                          type="select"
                          name="tax_rate"
                          id="tax_rate"
                          value={
                            values.tax_rate !== undefined &&
                            values.tax_rate !== null &&
                            values.tax_rate !== ""
                              ? String(parseFloat(values.tax_rate) || 0)
                              : "0"
                          }
                          onChange={onChange}
                          disabled={setting.viewonly && !setting.add}
                        >
                          <option value="0">0% (Không thuế / 0%)</option>
                          <option value="5">5% (Thuế suất 5%)</option>
                          <option value="8">8% (Thuế suất 8%)</option>
                          <option value="10">10% (Thuế suất 10%)</option>
                          {![0, 5, 8, 10].includes(parseFloat(values.tax_rate)) &&
                            parseFloat(values.tax_rate) > 0 && (
                              <option value={String(parseFloat(values.tax_rate))}>
                                {parseFloat(values.tax_rate)}% (Thuế suất {parseFloat(values.tax_rate)}%)
                              </option>
                            )}
                        </Input>
                      </FormGroup>
                    </Colxx>
                  </Row>

                {/* STOCK INFO - Thông tin tồn kho cho Fashion/Retail/Grocery */}
                {business_type &&
                  business_type !== "cafe" &&
                  business_type !== "restaurant" &&
                  generatedVariants.length === 0 && (
                    <>
                      <div className="custom-line mb-4 mt-3" />
                      <StockInfo
                        title={editProduct ? "Bổ sung nguyên liệu" : "Tạo tồn kho"}
                        quantity={values.stock_quantity ?? ""}
                        costPrice={values.stock_cost_price ?? ""}
                        sellingPrice={values.price ?? ""}
                        onChangeQuantity={(val) =>
                          onChange(val, "stock_quantity")
                        }
                        onChangeCostPrice={(val) =>
                          onChange(val, "stock_cost_price")
                        }
                        quantityPlaceholder="Nhập số lượng tồn kho"
                        costPricePlaceholder="Nhập giá vốn mỗi đơn vị"
                        disabled={setting.viewonly && !setting.add}
                      />
                    </>
                  )}
                </section>

                {isFoodService && values.fnb_type === "drink" ? (
                  <section className="product-add-section">
                    <div className="product-add-section-title">
                      Tùy chọn khẩu vị (Đá &amp; Đường)
                    </div>
                    {/* ICE */}
                    <FormGroup className="mb-4">
                      {setting.viewonly && !setting.add ? (
                        <Label for="iceTitle" className="text-muted">
                          Lượng đá
                        </Label>
                      ) : (
                        <div className="d-flex">
                          <Input
                            className="mb-3 custom-input-underline w-30 pad-2px"
                            type="text"
                            name="iceTitle"
                            id="iceTitle"
                            disabled
                            value="Lượng đá"
                          />
                          <TooltipItem item={iceTooltip} id={14} />
                        </div>
                      )}
                      <IceAndSugar
                        selectedValue={values.ice}
                        onSelected={onChangeIceAndSugar}
                        name="ice"
                        disabled={setting.viewonly && !setting.add}
                      />
                    </FormGroup>

                    {/* SUGAR */}
                    <div className="custom-line mb-3 mt-3" />
                    <FormGroup className="mb-4">
                      {setting.viewonly && !setting.add ? (
                        <Label for="sugarTitle" className="text-muted">
                          Lượng đường
                        </Label>
                      ) : (
                        <div className="d-flex">
                          <Input
                            className="mb-3 custom-input-underline w-30 pad-2px"
                            type="text"
                            name="sugarTitle"
                            id="sugarTitle"
                            disabled
                            value="Lượng đường"
                          />
                          <TooltipItem item={sugarTooltip} id={15} />
                        </div>
                      )}
                      <IceAndSugar
                        selectedValue={values.sugar}
                        onSelected={onChangeIceAndSugar}
                        name="sugar"
                        disabled={setting.viewonly && !setting.add}
                      />
                    </FormGroup>
                  </section>
                ) : null}
              </Colxx>

              <Colxx lg="4" md="12" className="product-add-column product-add-column-3 product-add-column-right">
                <section className="product-add-section">
                  <div className="product-add-section-title">
                    {business_type === "cafe" ||
                    business_type === "restaurant"
                      ? "Tùy chọn bán hàng (Size & Topping)"
                      : "Thuộc tính sản phẩm"}
                  </div>
                {business_type === "cafe" || business_type === "restaurant" ? (
                  <>
                    <FormGroup className="mb-4">
                      {setting.viewonly && !setting.add ? (
                        <Label for="sizeTitle" className="text-muted">
                          Size
                        </Label>
                      ) : (
                        <div className="d-flex">
                          <Input
                            className="mb-3 custom-input-underline w-30 pad-2px"
                            type="text"
                            name="sizeTitle"
                            id="sizeTitle"
                            disabled
                            value="Size"
                          />
                          <TooltipItem item={sizeTooltip} id={13} />
                        </div>
                      )}
                      <SizeAndTopping
                        onAdd={() => onAddSizeAndTopping("size")}
                        onChange={onChangeSizeAndTopping}
                        onRemove={onRemoveSizeAndTopping}
                        name={"size"}
                        values={values.size}
                        disabled={setting.viewonly && !setting.add}
                      />
                    </FormGroup>
                  </>
                ) : null}
                {business_type === "cafe" || business_type === "restaurant" ? (
                  <>
                    <FormGroup className="mb-4">
                      <div className="d-flex">
                        <Input
                          className="mb-3 custom-input-underline w-30 pad-2px"
                          type="text"
                          name="flavorTitle"
                          id="flavorTitle"
                          disabled
                          value="Vị"
                        />
                      </div>
                      <SizeAndTopping
                        onAdd={() => onAddSizeAndTopping("flavor")}
                        onChange={onChangeSizeAndTopping}
                        onRemove={onRemoveSizeAndTopping}
                        name="flavor"
                        values={values.flavor || []}
                        disabled={setting.viewonly && !setting.add}
                      />
                    </FormGroup>
                  </>
                ) : null}
                {business_type === "cafe" || business_type === "restaurant" ? (
                  <>
                    <FormGroup className="mb-4">
                      {setting.viewonly && !setting.add ? (
                        <Label for="toppingTitle" className="text-muted">
                          Topping
                        </Label>
                      ) : (
                        <div className="d-flex">
                          <Input
                            className="mb-3 custom-input-underline w-30 pad-2px"
                            type="text"
                            name="toppingTitle"
                            id="toppingTitle"
                            disabled
                            value="Topping"
                          />
                          <TooltipItem item={toppingTooltip} id={13} />
                        </div>
                      )}
                      <SizeAndTopping
                        onAdd={() => onAddSizeAndTopping("topping")}
                        onChange={onChangeSizeAndTopping}
                        onRemove={onRemoveSizeAndTopping}
                        name={"topping"}
                        values={values.topping}
                        disabled={setting.viewonly && !setting.add}
                      />
                    </FormGroup>
                  </>
                ) : null}


                {business_type !== "cafe" && business_type !== "restaurant" && (
                  <>
                    <div className="custom-line mb-3 mt-3" />
                    <FormGroup className="has-float-label mt-3">
                      <Label for="size" className="text-muted">
                        <IntlMessages id="product.size" />
                      </Label>
                      <Creatable
                        isMulti
                        onChange={(val) => onChange(val, "size")}
                        options={allSizeOptions}
                        value={values.size}
                        name={"size"}
                        placeholder={"Chọn size hoặc tạo mới"}
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                        }}
                      />
                    </FormGroup>
                    {business_type === "fashion" && (
                      <FormGroup className="has-float-label">
                        <Label for="color" className="text-muted">
                          <IntlMessages id="product.color" />
                        </Label>
                        <Creatable
                          isMulti
                          onChange={(val) => onChange(val, "color")}
                          options={allColorOptions}
                          value={values.color}
                          name={"color"}
                          placeholder={"Chọn màu sắc hoặc tạo mới"}
                          styles={{
                            menu: (provided) => ({
                              ...provided,
                              zIndex: 9999,
                            }),
                          }}
                        />
                      </FormGroup>
                    )}
                    {(business_type === "fashion" ||
                      business_type === "retail") && (
                      <FormGroup className="has-float-label">
                        <Label for="material" className="text-muted">
                          <IntlMessages id="product.material" />
                        </Label>
                        <Creatable
                          isMulti
                          onChange={(val) => onChange(val, "material")}
                          options={allMaterialOptions}
                          value={values.material}
                          name={"material"}
                          placeholder={"Chọn chất liệu hoặc tạo mới"}
                          styles={{
                            menu: (provided) => ({
                              ...provided,
                              zIndex: 9999,
                            }),
                          }}
                        />
                      </FormGroup>
                    )}
                    <div className="mb-3 align-items-center">
                      <Button
                        size="sm"
                        outline
                        color="info"
                        className="mr-2"
                        onClick={handleGenerateVariants}
                      >
                        Tạo biến thể tự động
                      </Button>
                    </div>
                    {generatedVariants.length > 0 && (
                      <>
                        <div className="product-add-subsection-title mb-3">
                          Danh sách biến thể đã tạo ({generatedVariants.length})
                        </div>
                        <Card className="mb-4">
                          <CardBody className="p-3">
                            <h6 className="mb-4">Áp dụng hàng loạt</h6>
                            <div className="d-flex overflow-hidden mb-2 pt-2">
                              <Colxx
                                xs={4}
                                className="pr-1 has-float-label p-0"
                              >
                                <FormGroup className="mb-0">
                                  <Label>Giá bán chung</Label>
                                  <PriceInput
                                    value={masterVariantSettings.price}
                                    name="price"
                                    placeholder="Nhập giá bán chung"
                                    onChange={(val, name) =>
                                      handleMasterSettingsChange(val, name)
                                    }
                                  />
                                </FormGroup>
                              </Colxx>
                              <Colxx
                                xs={4}
                                className="px-1 has-float-label p-0"
                              >
                                <FormGroup className="mb-0">
                                  <Label>Giá sỉ chung</Label>
                                  <PriceInput
                                    value={masterVariantSettings.price_wholesale}
                                    name="price_wholesale"
                                    placeholder="Nhập giá sỉ chung"
                                    onChange={(val, name) =>
                                      handleMasterSettingsChange(val, name)
                                    }
                                  />
                                </FormGroup>
                              </Colxx>
                              <Colxx xs={4} className="pl-1 has-float-label p-0">
                                <FormGroup className="mb-0">
                                  <Label>Giá khuyến mãi chung</Label>
                                  <PriceInput
                                    value={masterVariantSettings.promo_price}
                                    name="promo_price"
                                    placeholder="Nhập giá khuyến mãi chung"
                                    onChange={(val, name) =>
                                      handleMasterSettingsChange(val, name)
                                    }
                                  />
                                </FormGroup>
                              </Colxx>
                            </div>
                            {business_type !== "cafe" &&
                              business_type !== "restaurant" && (
                                <div className="d-flex overflow-hidden mb-2 pt-2">
                                  <Colxx
                                    xs={4}
                                    className="pr-1 has-float-label p-0"
                                  >
                                    <FormGroup className="mb-0">
                                      <Label>Số lượng chung</Label>
                                      <PriceInput
                                        value={masterVariantSettings.quantity}
                                        name="quantity"
                                        placeholder="Nhập số lượng"
                                        onChange={(val, name) =>
                                          handleMasterSettingsChange(val, name)
                                        }
                                      />
                                    </FormGroup>
                                  </Colxx>
                                  <Colxx
                                    xs={4}
                                    className="px-1 has-float-label p-0"
                                  >
                                    <FormGroup className="mb-0">
                                      <Label>Giá vốn chung</Label>
                                      <PriceInput
                                        value={masterVariantSettings.cost_price}
                                        name="cost_price"
                                        placeholder="Nhập giá vốn"
                                        onChange={(val, name) =>
                                          handleMasterSettingsChange(val, name)
                                        }
                                      />
                                    </FormGroup>
                                  </Colxx>
                                  <Colxx
                                    xs={4}
                                    className="pl-1 has-float-label p-0"
                                  >
                                    <FormGroup className="mb-0">
                                      <Label>Quy đổi chung</Label>
                                      <PriceInput
                                        value={masterVariantSettings.exchange_value}
                                        name="exchange_value"
                                        placeholder="1"
                                        onChange={(val, name) =>
                                          handleMasterSettingsChange(val, name)
                                        }
                                      />
                                    </FormGroup>
                                  </Colxx>
                                </div>
                              )}
                            {masterVariantSettings.promo_price !== "" ? (
                              <div className="d-flex mb-2 pt-2">
                                <Colxx
                                  xs={6}
                                  className="pr-2 has-float-label p-0"
                                >
                                  <FormGroup className="mb-0">
                                    <Label>Ngày bắt đầu chung</Label>
                                    <DatePicker
                                      placeholderText="Chọn ngày bắt đầu"
                                      selected={
                                        masterVariantSettings.date_start
                                      }
                                      onChange={(date) =>
                                        handleMasterSettingsChange(
                                          date,
                                          "date_start",
                                        )
                                      }
                                      dateFormat="YYYY-MM-DD"
                                    />
                                  </FormGroup>
                                </Colxx>
                                <Colxx xs={6} className="has-float-label p-0">
                                  <FormGroup className="mb-0">
                                    <Label>Ngày kết thúc chung</Label>
                                    <DatePicker
                                      placeholderText="Chọn ngày kết thúc"
                                      selected={masterVariantSettings.date_end}
                                      onChange={(date) =>
                                        handleMasterSettingsChange(
                                          date,
                                          "date_end",
                                        )
                                      }
                                      dateFormat="YYYY-MM-DD"
                                      popperPlacement="bottom-end"
                                    />
                                  </FormGroup>
                                </Colxx>
                              </div>
                            ) : null}
                            <div className="d-flex justify-item-end mt-4">
                              <Button
                                color="primary"
                                onClick={applyMasterSettingsToAll}
                                className="d-flex align-items-center"
                              >
                                <i className="simple-icon-check mr-2" />
                                Áp dụng cho tất cả biến thể
                              </Button>
                            </div>
                          </CardBody>
                        </Card>
                      </>
                    )}
                    {generatedVariants.length > 0 &&
                      generatedVariants.map((variant, idx) => (
                        <div
                          key={variant.id}
                          className={`variant-card-wrapper mb-2 ${
                            editProduct ? "variant-card-update" : ""
                          }`}
                        >
                          <Button
                            close
                            className="variant-delete-button"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDeleteVariant(variant.id);
                            }}
                            aria-label="Xóa biến thể"
                          />
                          <Card>
                            <CardBody
                              className="d-flex justify-content-between align-items-center p-3"
                              onClick={() => toggleAccordionVariations(idx)}
                              style={{ cursor: "pointer" }}
                              aria-expanded={variant.isOpen}
                            >
                              <div className="font-weight-bold mr-2">
                                {variant.size.label}
                              </div>
                              {variant.color && variant.color.label && (
                                <div className="mr-2">
                                  {variant.color.label}
                                </div>
                              )}
                              {variant.material && variant.material.label && (
                                <div>({variant.material.label})</div>
                              )}
                              <i
                                className={`simple-icon-arrow-${
                                  variant.isOpen ? "up" : "down"
                                }`}
                              ></i>
                            </CardBody>
                            <Collapse isOpen={variant.isOpen}>
                              <div className="has-float-label mb-2 d-flex align-items-center px-3">
                                <Colxx xs={6} md={6} lg={6} className="px-0">
                                  SKU: {`${sku}.${idx + 1}`}
                                </Colxx>
                                {/* Ẩn số lượng nhập cho Cafe/Restaurant */}
                                {business_type !== "cafe" &&
                                  business_type !== "restaurant" && (
                                    <Colxx
                                      xs={6}
                                      md={6}
                                      lg={6}
                                      className="pr-0 has-float-label"
                                    >
                                      <FormGroup className="mb-0">
                                        <Label for="product.quantity">
                                          Số lượng nhập{" "}
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </Label>
                                        <PriceInput
                                          value={variant.quantity}
                                          placeholder="Nhập số lượng"
                                          onChange={(val) =>
                                            handleVariantChange(
                                              val,
                                              variant.id,
                                              "quantity",
                                            )
                                          }
                                        />
                                      </FormGroup>
                                    </Colxx>
                                  )}
                              </div>
                              <div className="d-flex overflow-hidden mb-2 pt-2">
                                <Colxx
                                  xs={4}
                                  md={4}
                                  lg={4}
                                  className="pr-1 has-float-label"
                                >
                                  <FormGroup className="mb-0">
                                    <Label for="product.name">
                                      Giá bán{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </Label>
                                    <PriceInput
                                      value={variant.price}
                                      name="price"
                                      placeholder="Nhập giá bán"
                                      onChange={(val) =>
                                        handleVariantChange(
                                          val,
                                          variant.id,
                                          "price",
                                        )
                                      }
                                    />
                                  </FormGroup>
                                </Colxx>
                                <Colxx
                                  xs={4}
                                  md={4}
                                  lg={4}
                                  className="px-1 has-float-label"
                                >
                                  <FormGroup className="mb-0">
                                    <Label for="product.price_wholesale">
                                      Giá bán sỉ
                                    </Label>
                                    <PriceInput
                                      value={variant.price_wholesale}
                                      name="price_wholesale"
                                      placeholder="Nhập giá bán sỉ"
                                      onChange={(val) =>
                                        handleVariantChange(
                                          val,
                                          variant.id,
                                          "price_wholesale",
                                        )
                                      }
                                    />
                                  </FormGroup>
                                </Colxx>
                                <Colxx
                                  xs={4}
                                  md={4}
                                  lg={4}
                                  className="pl-1 has-float-label"
                                >
                                  <FormGroup className="mb-0">
                                    <Label for="product.value">
                                      Giá khuyến mãi
                                    </Label>
                                    <PriceInput
                                      value={variant.promo_price}
                                      name="promo_price"
                                      placeholder="Nhập giá khuyến mãi"
                                      onChange={(val) =>
                                        handleVariantChange(
                                          val,
                                          variant.id,
                                          "promo_price",
                                        )
                                      }
                                    />
                                  </FormGroup>
                                </Colxx>
                              </div>
                              {Number(variant.promo_price) > 0 ? (
                                <div className="d-flex mb-2 pt-2">
                                  <Colxx
                                    xs={6}
                                    md={6}
                                    lg={6}
                                    className="pr-0 has-float-label"
                                  >
                                    <FormGroup className="has-float-label">
                                      <Label
                                        for="date_start"
                                        className="text-muted"
                                      >
                                        Ngày bắt đầu
                                      </Label>
                                      <DatePicker
                                        name="date_start"
                                        id="date_start"
                                        placeholderText="Chọn ngày bắt đầu"
                                        onChange={(date) => {
                                          handleVariantChange(
                                            date,
                                            variant.id,
                                            "date_start",
                                          );
                                        }}
                                        selected={
                                          variant.date_start
                                            ? moment(variant.date_start)
                                            : null
                                        }
                                        dateFormat="YYYY-MM-DD"
                                      />
                                    </FormGroup>
                                  </Colxx>
                                  <Colxx
                                    xs={6}
                                    md={6}
                                    lg={6}
                                    className="has-float-label"
                                  >
                                    <FormGroup className="has-float-label">
                                      <Label
                                        for="date_end"
                                        className="text-muted"
                                      >
                                        Ngày kết thúc
                                      </Label>
                                      <DatePicker
                                        name="date_end"
                                        id="date_end"
                                        placeholderText="Chọn ngày kết thúc"
                                        onChange={(date) => {
                                          handleVariantChange(
                                            date,
                                            variant.id,
                                            "date_end",
                                          );
                                        }}
                                        selected={
                                          variant.date_end
                                            ? moment(variant.date_end)
                                            : null
                                        }
                                        dateFormat="YYYY-MM-DD"
                                        popperPlacement="bottom-end"
                                      />
                                    </FormGroup>
                                  </Colxx>
                                </div>
                              ) : null}
                              {business_type !== "cafe" &&
                                business_type !== "restaurant" && (
                                  <div className="d-flex overflow-hidden mb-2 pt-2">
                                    <Colxx
                                      xs={6}
                                      md={6}
                                      lg={6}
                                      className="pr-1 has-float-label"
                                    >
                                      <FormGroup className="mb-0">
                                        <Label for="product.cost_price">
                                          Giá vốn{" "}
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </Label>
                                        <PriceInput
                                          value={variant.cost_price}
                                          name="cost_price"
                                          placeholder="Nhập giá vốn"
                                          onChange={(val) =>
                                            handleVariantChange(
                                              val,
                                              variant.id,
                                              "cost_price",
                                            )
                                          }
                                        />
                                      </FormGroup>
                                    </Colxx>
                                    <Colxx
                                      xs={6}
                                      md={6}
                                      lg={6}
                                      className="pl-1 has-float-label"
                                    >
                                      <FormGroup className="mb-0">
                                        <Label for="product.exchange_value">
                                          Quy đổi
                                        </Label>
                                        <PriceInput
                                          value={variant.exchange_value || "1"}
                                          name="exchange_value"
                                          placeholder="1"
                                          onChange={(val) =>
                                            handleVariantChange(
                                              val,
                                              variant.id,
                                              "exchange_value",
                                            )
                                          }
                                        />
                                      </FormGroup>
                                    </Colxx>
                                  </div>
                                )}
                            </Collapse>
                          </Card>
                        </div>
                      ))}
                  </>
                )}
                </section>

                {(business_type === "cafe" ||
                  business_type === "restaurant") && (
                  <section className="product-add-section">
                    <div className="product-add-section-title">
                      Định lượng nguyên liệu
                    </div>
                    <RecipeBuilder
                      ingredients={values.ingredients || []}
                      data_stocks={data_stocks}
                      onChange={(ingredients) =>
                        onChange(ingredients, "ingredients")
                      }
                      disabled={setting.viewonly && !setting.add}
                    />
                  </section>
                )}
              </Colxx>
            </Row>
          </PerfectScrollbar>
        </div>
        <ModalFooter>
          <Button
            type="submit"
            disabled={isSavingProduct}
            color="primary"
          >
            {editProduct ? (
              values?.isTemplate ? (
                <IntlMessages id="template.convert" />
              ) : (
                <IntlMessages id="product.btn-update" />
              )
            ) : (
              <IntlMessages id="product.btn-add" />
            )}
          </Button>{" "}
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default memo(ContentComponent);

const GetImage = (image) => {
  if (image.target.files) {
    console.log(image.target.files);

    return image.target.files[0].name;
  }

  return image;
};
